import { StyleSheet, StyleProp } from "react-native";

export function flatten(style: StyleProp<any> | StyleProp<any>[]): StyleProp<any> {
    return StyleSheet.flatten(style)
}